export const LocalBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "ImpactIsol",
    // Google n'accepte pas le SVG pour image/logo
    "image": "https://www.impactisol.com/images/og-impactisol.jpg",
    "logo": "https://www.impactisol.com/images/LogoImpact.png",
    // Relie le site à la page LinkedIn de l'entreprise
    "sameAs": [
        "https://www.linkedin.com/company/impactisol-calorifuge/"
    ],
    "telephone": "+33625837471",
    "email": "contact@impactisol.fr",
    "url": "https://www.impactisol.com",

    "address": {
        "@type": "PostalAddress",
        "streetAddress": "500 Route du Ruisset",
        "addressLocality": "Noyarey",
        "postalCode": "38360",
        "addressCountry": "FR"
    },

    "geo": {
        "@type": "GeoCoordinates",
        "latitude": 45.2475,
        "longitude": 5.6330
    },

    "areaServed": [
        { "@type": "AdministrativeArea", "name": "Auvergne-Rhône-Alpes" },
        { "@type": "AdministrativeArea", "name": "Isère" },
        { "@type": "AdministrativeArea", "name": "Savoie" },
        { "@type": "AdministrativeArea", "name": "Haute-Savoie" },
        { "@type": "AdministrativeArea", "name": "Rhône" },
        { "@type": "AdministrativeArea", "name": "Ain" },
        // Chantiers aussi ailleurs en France
        { "@type": "Country", "name": "France" }
    ],

    "priceRange": "€€",
    "description": "Expert en calorifugeage et isolation thermique industrielle et tertiaire, basé à Noyarey près de Grenoble. Intervention en Isère, Auvergne-Rhône-Alpes, et partout en France.",

    "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday"
        ],
        "opens": "08:30",
        "closes": "17:30"
    }
};
